import { useMemo } from 'react';
import StackAdapt from '../stackadapt';

const DisplayRetail = (props) => {
    const reportProfile = useMemo(() => {
        if (!props.reportProfile) return props.reportProfile;
        return {
            ...props.reportProfile,
            showCost: false
        };
    }, [props.reportProfile]);

    return (
        <StackAdapt
            {...props}
            reportProfile={reportProfile}
            awarenessMode={true}
            retailMode={true}
        />
    );
};

export default DisplayRetail;
